import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { Field, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import ListingOptionCardField from '../../common-pages/ListingOptions/components/ListingOptionCardField';
import ListingContext from '../../providers/Listing/Listing.context';
import { ListingPackage } from 'models/Listing';
import RadioGroupField from 'components/RadioGroupField';
import CartIcon from 'icons/Cart.icon';
import LockclosedIcon from 'icons/Lockclosed.icon';
import validations from 'validations';
import PatchListingContext from '../../providers/PatchListing/PatchListing.context';

import './GetBuyers.styles.scss';
import './GetBuyers.styles.responsive.scss';

type GetBuyersProps = {
  className?: string;
  brokerLogo?: string;
  brokerAvatar?: string;
  options: ListingPackage[];
};

export const GET_BUYERS_OPTIONS = {
  PRIVATE: 'private',
  RESOLVE_BUYERS: 'resolve-buyers',
} as const;

const GET_BUYERS = 'getBuyers';

const GetBuyers: React.FC<GetBuyersProps> = (props) => {
  const { className, options } = props;

  const {
    listing: { listingContact, listingContacts },
  } = useContext(ListingContext);
  const { patchListingValue } = useContext(PatchListingContext);

  const { values } = useFormState();

  const { t } = useTranslation();

  const brokerAvatar = listingContacts?.[0]?.brokerImage?.url;
  const brokerLogo = listingContact?.firmLogo?.url;

  const getBuyersOptions = useMemo(
    () => [
      {
        label: (
          <div>
            <LockclosedIcon />
            <div>
              <span>{t('privateListingOptionTitle')}</span>
              <span>{t('privateListingOptionDescription')}</span>
            </div>
          </div>
        ),
        value: GET_BUYERS_OPTIONS.PRIVATE,
      },
      {
        label: (
          <div>
            <CartIcon />
            <div>
              <span>
                {t('resolveBuyersOptionsTitle')}
                <span className="recommended">{t('recommended')}</span>
              </span>
              <span>{t('resolveBuyersOptionsDescription')}</span>
            </div>
          </div>
        ),
        value: GET_BUYERS_OPTIONS.RESOLVE_BUYERS,
      },
    ],
    [t],
  );

  const classes = classNames('get-buyers', className);

  return (
    <div className={classes}>
      <div className="lcw-page__heading">
        <p className="lcw-page__heading__title">{t('whereWillYouGetBuyers')}</p>
      </div>

      <RadioGroupField name={GET_BUYERS} options={getBuyersOptions} styled />

      {values[GET_BUYERS] === GET_BUYERS_OPTIONS.RESOLVE_BUYERS && (
        <>
          <div className="lcw-page__heading">
            <p className="lcw-page__heading__title">
              {t('resolvesMarketListingPackages')}
            </p>
          </div>
          <Field
            name="listingPackage"
            component={ListingOptionCardField}
            options={options}
            validate={validations.required()}
            brokerAvatar={brokerAvatar}
            brokerLogo={brokerLogo}
            customOnChange={(listingPackage: ListingPackage) =>
              patchListingValue({ listingPackage })
            }
          />

          <p className="get-buyers__disclaimer">{t('pricesExcludeGST')}</p>
        </>
      )}
    </div>
  );
};

export default GetBuyers;
